export const BOOKING_URL =
  "https://book.squareup.com/appointments/jyhfxa33y2om57/location/LA207KVMHPEHD/services";

export const TIKTOK_URL = "https://www.tiktok.com/@marrmobiledetailing";
export const INSTAGRAM_URL = "https://www.instagram.com/marrmobiledetailing";

export const NAV_LINKS = [
  { label: "Home", hash: "#home" },
  { label: "About", hash: "#about" },
  { label: "Services", hash: "#services" },
  { label: "Gallery", hash: "#gallery" },
  { label: "Contact", hash: "#contact" },
];

export const PACKAGES = [
  {
    id: "basic",
    index: "01",
    name: "Basic Detail",
    price: "$60",
    icon: "droplets",
    includes: [
      "Exterior hand wash",
      "Tire shine",
      "Interior vacuum",
      "Window cleaning",
      "Wipe down of surfaces",
    ],
  },
  {
    id: "interior",
    index: "02",
    name: "Interior Detail",
    price: "$100",
    icon: "armchair",
    includes: [
      "Deep vacuum",
      "Dashboard & console cleaning",
      "Seat shampoo",
      "Carpet cleaning",
      "Door jamb cleaning",
      "Odor treatment",
    ],
  },
  {
    id: "exterior",
    index: "03",
    name: "Exterior Detail",
    price: "$120",
    icon: "car",
    includes: [
      "Foam bath hand wash",
      "Clay bar treatment",
      "Spray wax protection",
      "Rim & tire cleaning",
      "Tire shine",
      "Streak-free windows",
    ],
  },
  {
    id: "full",
    index: "04",
    name: "Full Detail Package",
    price: "$180",
    icon: "sparkles",
    featured: true,
    includes: [
      "Full interior detail",
      "Full exterior detail",
      "Wax protection",
      "Seat & carpet shampoo",
      "Trim dressing",
      "Complete vehicle refresh",
    ],
  },
];

export const ADD_ONS = [
  { name: "Pet Hair Removal", price: "$25+", icon: "paw" },
  { name: "Engine Bay Cleaning", price: "$40", icon: "engine" },
  { name: "Headlight Restoration", price: "$50", icon: "headlight" },
  { name: "Ceramic Coating", price: "$150+", icon: "shield" },
  { name: "Paint Correction", price: "$200+", icon: "buffer" },
];

export const SERVICE_AREAS = ["Melbourne, FL", "Palm Bay, FL", "Satellite Beach, FL"];

// Real phone set. Email is still a placeholder — swap when ready.
export const CONTACT_PHONE = "+1 (321) 890-7627";
export const CONTACT_EMAIL = "bookings@marrmobiledetailing.com";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/14487132/pexels-photo-14487132.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  about: "https://images.unsplash.com/photo-1694678505383-676d78ea3b96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxjYXIlMjBkZXRhaWxpbmclMjB3YXNoJTIwZm9hbXxlbnwwfHx8fDE3OTAyODIyMTV8MA&ixlib=rb-4.1.0&q=85",
  serviceSide: "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxjYXIlMjB3YXNoJTIwZm9hbSUyMHNvYXAlMjBkYXJrfGVufDB8fHx8MTc5MDI4MjMyN3ww&ixlib=rb-4.1.0&q=85",
  gallery: [
    { src: "https://images.pexels.com/photos/29755711/pexels-photo-29755711.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Gloss & reflection", span: "md:col-span-2 md:row-span-2" },
    { src: "https://images.unsplash.com/photo-1605164598708-25701594473e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxjYXIlMjB3YXNoJTIwZm9hbSUyMHNvYXAlMjBkYXJrfGVufDB8fHx8MTc5MDI4MjMyN3ww&ixlib=rb-4.1.0&q=85", label: "Foam bath", span: "md:col-span-2" },
    { src: "https://images.pexels.com/photos/14908957/pexels-photo-14908957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Paint correction", span: "" },
    { src: "https://images.unsplash.com/photo-1565689876697-e467b6c54da2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxjYXIlMjB3YXNoJTIwZm9hbSUyMHNvYXAlMjBkYXJrfGVufDB8fHx8MTc5MDI4MjMyN3ww&ixlib=rb-4.1.0&q=85", label: "Rim & tire", span: "" },
    { src: "https://images.pexels.com/photos/15469368/pexels-photo-15469368.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Headlight detail", span: "" },
    { src: "https://images.unsplash.com/photo-1513036191774-b2badb8fcb76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxzaGlueSUyMHNwb3J0cyUyMGNhcnxlbnwwfHx8fDE3OTAyODIyMTV8MA&ixlib=rb-4.1.0&q=85", label: "Showroom finish", span: "md:col-span-2" },
  ],
};
